
const parseToNumber = (value) => {
  if (typeof value === 'number') return value;

  if (typeof value === 'string') {
    
    const cleaned = value.replace(/[^0-9.-]+/g, '');
    const num = Number(cleaned);
    return isNaN(num) ? 0 : num;
  }

  return 0; 
};


export const formatINRCurrencyWithDecimals = (value) => {
  const num = parseToNumber(value);
  return num.toLocaleString('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};


export const formatINRCurrencyNoDecimals = (value) => {
  const num = parseToNumber(value);
  return num.toLocaleString('en-IN', {
    maximumFractionDigits: 0,
  });
};
